import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { BreadcrumbTranslatePipe } from '../../Pipes/BreadcrumbTranslatePipe.pipe';

@Component({
  selector: 'debtor-panel-breadcrumb',
  standalone: true,
  imports: [RouterModule, BreadcrumbTranslatePipe],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent {
  private breadcrumbService = inject(BreadcrumbService);
  protected readonly breadcrumbs = this.breadcrumbService.breadcrumbs;
}